/* Saydoodle page script. Runs only on the vf-saydoodle template. */
(function () {
  'use strict';
  var cfgEl = document.getElementById('sd-config');
  if (!cfgEl) return;
  var CFG = JSON.parse(cfgEl.textContent);
  document.body.classList.add('sd-page');

  var $ = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };
  var money = function (cents) {
    var v = (cents / 100).toFixed(2);
    return '$' + v.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  };
  var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- state ---------- */
  var state = { set: CFG.defaultSet, addons: {} };
  function variant(set) {
    set = set || state.set;
    for (var i = 0; i < CFG.variants.length; i++) if (CFG.variants[i].s === set) return CFG.variants[i];
    return CFG.variants[0];
  }
  function isKit() { return state.set === CFG.kitSet; }
  function shortName() {
    for (var i = 0; i < CFG.sets.length; i++) if (CFG.sets[i].value === state.set) return CFG.sets[i].short;
    return state.set;
  }
  function total() {
    var t = variant().price;
    if (!isKit()) CFG.addons.forEach(function (a) { if (state.addons[a.id]) t += a.price; });
    return t;
  }

  function render() {
    var v = variant();
    var offer = $('#sd-offer');
    if (offer) {
      offer.classList.toggle('is-single', state.set === CFG.singleSet);
      offer.classList.toggle('is-kit', isKit());
    }
    $$('[data-sd-set]').forEach(function (b) {
      var on = b.dataset.sdSet === state.set;
      b.classList.toggle('is-selected', on);
      b.setAttribute('aria-checked', on ? 'true' : 'false');
    });
    var now = $('[data-sd-price]'); if (now) now.textContent = money(v.price);
    var was = $('[data-sd-was]'); var save = $('[data-sd-save]');
    if (v.compare && v.compare > v.price) {
      if (was) { was.hidden = false; was.textContent = money(v.compare); }
      if (save) { save.hidden = false; save.textContent = 'Save ' + money(v.compare - v.price); }
    } else { if (was) was.hidden = true; if (save) save.hidden = true; }
    $$('.sd-addon').forEach(function (b) { b.setAttribute('aria-pressed', state.addons[b.dataset.addon] ? 'true' : 'false'); });
    $$('[data-sd-total]').forEach(function (el) { el.textContent = money(total()); });
    $$('[data-sd-sticky-name]').forEach(function (el) { el.textContent = shortName(); });
    var vi = $('input[name="id"][data-sd-variant-input]'); if (vi) vi.value = v.id;
  }

  function scrollToOffer() {
    var box = document.getElementById('sd-offer');
    if (box) box.scrollIntoView({ behavior: reduced ? 'auto' : 'smooth', block: 'center' });
  }
  $$('[data-sd-set]').forEach(function (b) {
    b.addEventListener('click', function () { state.set = b.dataset.sdSet; render(); showVariantMedia(); });
  });
  $$('[data-sd-select-set]').forEach(function (b) {
    b.addEventListener('click', function () { state.set = b.dataset.sdSelectSet; render(); showVariantMedia(); if (!b.closest('#sd-offer')) scrollToOffer(); });
  });
  $$('.sd-addon').forEach(function (b) {
    b.addEventListener('click', function () { state.addons[b.dataset.addon] = !state.addons[b.dataset.addon]; render(); });
  });

  /* ---------- cart ---------- */
  function drawer() { return document.querySelector('cart-drawer'); }
  function sectionIds() { var d = drawer(); return d && d.getSectionsToRender ? d.getSectionsToRender().map(function (s) { return s.id; }) : []; }
  function setCount(n) { $$('[data-sd-count]').forEach(function (el) { el.textContent = n; el.hidden = !n; }); }
  function fetchCart() { return fetch(CFG.routes.root + 'cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }); }
  function post(path, body) {
    return fetch(CFG.routes.root + path, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) })
      .then(function (r) { return r.text().then(function (t) { var j; try { j = JSON.parse(t); } catch (e) { throw new Error(CFG.strings.error); } if (!r.ok || j.status) throw new Error(j.description || j.message || CFG.strings.error); return j; }); });
  }
  function paintDrawer(j, open, btn) {
    var d = drawer();
    if (!d || typeof d.renderContents !== 'function') { if (open) window.location.href = CFG.routes.cart; return; }
    if (j && j.sections) d.renderContents(j);
    if (typeof j.item_count === 'number') d.classList.toggle('is-empty', j.item_count === 0);
    if (open && typeof d.open === 'function' && !d.classList.contains('active')) d.open(btn);
  }
  function vipFirst() {
    var sheet = document.querySelector('.vf-root'), bag = drawer();
    if (!sheet || !bag || sheet.classList.contains('open')) return;
    var hide = { visibility: 'hidden', opacity: '0', 'pointer-events': 'none', transition: 'none' };
    Object.keys(hide).forEach(function (k) { bag.style.setProperty(k, hide[k], 'important'); });
    var ticks = 0, tm = setInterval(function () {
      if (sheet.classList.contains('open') || ++ticks >= 15) { clearInterval(tm); Object.keys(hide).forEach(function (k) { bag.style.removeProperty(k); }); }
    }, 100);
  }

  /* the free roll pack follows the printer: one gift and the gift code while a Saydoodle is in the cart, none without it */
  var syncing = null;
  function syncGifts() {
    if (syncing) return syncing;
    syncing = fetchCart().then(function (cart) {
      var hasMain = cart.items.some(function (i) { return i.product_id === CFG.productId; });
      var code = (CFG.giftCode || '').toUpperCase();
      var codes = (cart.discount_codes || []).map(function (c) { return c.code; });
      var others = codes.filter(function (c) { return c.toUpperCase() !== code; });
      var hasCode = codes.length !== others.length;
      var updates = {}, change = false;
      if (hasMain) {
        CFG.gifts.forEach(function (g) {
          var lines = cart.items.filter(function (i) { return i.variant_id === g.id; });
          if (!lines.length) { updates[g.id] = 1; change = true; }
          lines.forEach(function (l, k) { var want = k === 0 ? 1 : 0; if (l.quantity !== want) { updates[l.key] = want; change = true; } });
        });
      } else {
        var giftIds = CFG.gifts.map(function (g) { return g.id; });
        cart.items.forEach(function (i) { if (giftIds.indexOf(i.variant_id) > -1 || (i.properties && i.properties._gift === 'saydoodle')) { updates[i.key] = 0; change = true; } });
      }
      var wantCode = hasMain && code;
      if (!change && (wantCode ? hasCode : !hasCode)) { setCount(cart.item_count); return cart; }
      var body = { updates: updates, sections: sectionIds(), sections_url: window.location.pathname };
      body.discount = others.concat(wantCode ? [CFG.giftCode] : []).join(',');
      return post('cart/update.js', body).then(function (j) { paintDrawer(j, false); setCount(j.item_count); return j; });
    }).catch(function () { return null; }).then(function (c) { syncing = null; return c; });
    return syncing;
  }

  function cartItems(inCart) {
    var v = variant();
    var items = [{ id: v.id, quantity: 1 }];
    if (!isKit()) CFG.addons.forEach(function (a) { if (state.addons[a.id]) items.push({ id: a.id, quantity: 1 }); });
    CFG.gifts.forEach(function (g) { if (!inCart[g.id]) items.push({ id: g.id, quantity: 1, properties: { _gift: 'saydoodle' } }); });
    return items;
  }

  function addToCart(btn) {
    var errs = $$('[data-sd-error]');
    errs.forEach(function (e) { e.hidden = true; });
    var buttons = $$('[data-sd-add]');
    if (buttons.some(function (b) { return b.classList.contains('is-loading'); })) return Promise.resolve();
    buttons.forEach(function (b) { b.classList.add('is-loading'); b.setAttribute('aria-busy', 'true'); });
    return fetchCart().then(function (cart) {
      var inCart = {};
      cart.items.forEach(function (i) { inCart[i.variant_id] = (inCart[i.variant_id] || 0) + i.quantity; });
      var d = drawer();
      if (d && d.setActiveElement) d.setActiveElement(btn);
      return fetch(CFG.routes.add, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: cartItems(inCart), sections: sectionIds(), sections_url: window.location.pathname })
      }).then(function (r) { return r.json().then(function (j) { return { ok: r.ok, body: j }; }); });
    }).then(function (res) {
      if (!res.ok || res.body.status) throw new Error(res.body.description || res.body.message || CFG.strings.error);
      vipFirst();
      paintDrawer(res.body, false);
      return syncGifts().then(function (c) {
        return (c && typeof c.item_count === 'number' ? Promise.resolve(c) : fetchCart()).then(function (cc) {
          setCount(cc.item_count);
          paintDrawer({ item_count: cc.item_count }, true, btn);
        });
      });
    }).catch(function (e) {
      var msg = (e && e.message) ? e.message : CFG.strings.error;
      errs.forEach(function (el) { el.textContent = msg; el.hidden = false; });
      if (btn && !btn.closest('#sd-offer')) scrollToOffer();
    }).then(function () {
      buttons.forEach(function (b) { b.classList.remove('is-loading'); b.removeAttribute('aria-busy'); });
    });
  }
  $$('[data-sd-add]').forEach(function (b) {
    b.addEventListener('click', function (e) {
      e.preventDefault();
      if (b.dataset.sdAddSet) { state.set = b.dataset.sdAddSet; render(); }
      addToCart(b);
    });
  });
  $$('[data-sd-open-cart]').forEach(function (b) {
    b.addEventListener('click', function (e) {
      var d = drawer();
      if (!d || typeof d.open !== 'function') return;
      e.preventDefault();
      Promise.all([fetch(CFG.routes.root + '?sections=' + sectionIds().join(',')).then(function (r) { return r.json(); }), fetchCart()]).then(function (res) {
        d.renderContents({ id: 0, sections: res[0] });
        paintDrawer({ item_count: res[1].item_count }, true, b);
      }).catch(function () { d.open(b); });
    });
  });
  syncGifts();
  if (typeof window.subscribe === 'function' && window.PUB_SUB_EVENTS) {
    window.subscribe(window.PUB_SUB_EVENTS.cartUpdate, function () { clearTimeout(window.__sdSync); window.__sdSync = setTimeout(syncGifts, 300); });
  }
  document.addEventListener('click', function (e) {
    if (e.target.closest && e.target.closest('cart-remove-button, .quantity__button')) setTimeout(syncGifts, 1400);
  });
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('cart-drawer [name="checkout"], cart-drawer a[href$="/checkout"]');
    if (!b || b.dataset.sdReady === '1') return;
    e.preventDefault(); e.stopImmediatePropagation();
    syncGifts().then(function () { var n = document.querySelector('cart-drawer [name="checkout"]') || b; n.dataset.sdReady = '1'; n.click(); delete n.dataset.sdReady; });
  }, true);
  /* the shared reviews row puts a comma between the two names; this page joins them with a space */
  $$('.sd-buy__proofrow .ceyla-rproof__text').forEach(function (p) {
    Array.prototype.forEach.call(p.childNodes, function (n) { if (n.nodeType === 3 && n.textContent.trim() === ',') n.textContent = ' '; });
  });

  /* ---------- gallery ---------- */
  var track = $('.sd-gallery__track');
  var slides = track ? $$('.sd-gallery__slide', track) : [];
  var thumbs = $$('.sd-thumb');
  var current = 0;
  function go(i, smooth) {
    if (!track || !slides.length) return;
    i = Math.max(0, Math.min(slides.length - 1, i));
    track.scrollTo({ left: slides[i].offsetLeft, behavior: smooth && !reduced ? 'smooth' : 'auto' });
  }
  function mark(i) {
    current = i;
    thumbs.forEach(function (t, k) { t.classList.toggle('is-active', k === i); t.setAttribute('aria-current', k === i ? 'true' : 'false'); });
    var t = thumbs[i];
    if (t && t.parentNode) {
      var p = t.parentNode;
      p.scrollTo({ left: t.offsetLeft - p.clientWidth / 2 + t.clientWidth / 2, behavior: reduced ? 'auto' : 'smooth' });
    }
    slides.forEach(function (s, k) {
      var vv = s.querySelector('video'); if (!vv) return;
      if (k === i) { var pr = vv.play(); if (pr && pr.catch) pr.catch(function () {}); } else { vv.pause(); }
    });
  }
  function showVariantMedia() {
    var v = variant();
    if (!v.media) return;
    for (var i = 0; i < slides.length; i++) {
      if (String(slides[i].dataset.mediaId) === String(v.media)) { go(i, true); mark(i); return; }
    }
  }
  if (track) {
    var ticking = false;
    track.addEventListener('scroll', function () {
      if (ticking) return; ticking = true;
      requestAnimationFrame(function () {
        var i = Math.round(track.scrollLeft / track.clientWidth);
        if (i !== current) mark(i);
        ticking = false;
      });
    }, { passive: true });
    thumbs.forEach(function (t, i) { t.addEventListener('click', function () { go(i, true); mark(i); }); });
    var prev = $('.sd-gallery__nav--prev'), next = $('.sd-gallery__nav--next');
    if (prev) prev.addEventListener('click', function () { go(current - 1, true); });
    if (next) next.addEventListener('click', function () { go(current + 1, true); });
    mark(0);
  }

  /* ---------- shipping dates (local calendar days) ---------- */
  var MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
  function addDays(d, n) { var x = new Date(d.getFullYear(), d.getMonth(), d.getDate()); x.setDate(x.getDate() + n); return x; }
  function fmt(d) { return MONTHS[d.getMonth()] + ' ' + d.getDate(); }
  function fmtRange(a, b) { return a.getMonth() === b.getMonth() ? fmt(a) + '-' + b.getDate() : fmt(a) + ' - ' + fmt(b); }
  var lastDay = '';
  function dates() {
    var now = new Date();
    var key = now.toDateString();
    if (key === lastDay) return; lastDay = key;
    var s = CFG.ship;
    var shipped = addDays(now, s.ship), d1 = addDays(now, s.min), d2 = addDays(now, s.max);
    $$('[data-sd-date="order"]').forEach(function (el) { el.textContent = fmt(now); });
    $$('[data-sd-date="ship"]').forEach(function (el) { el.textContent = fmt(shipped); });
    $$('[data-sd-date="deliver"]').forEach(function (el) { el.textContent = fmtRange(d1, d2); });
    /* gift deadline: the last order day whose latest delivery still lands by Dec 24 */
    $$('[data-sd-deadline]').forEach(function (dl) {
      var eve = new Date(now.getFullYear(), 11, 24);
      var last = addDays(eve, -s.max);
      if (now <= last) {
        dl.hidden = false;
        var t = dl.querySelector('[data-sd-deadline-date]'); if (t) t.textContent = fmt(last);
      } else { dl.hidden = true; }
    });
  }
  dates();
  document.addEventListener('visibilitychange', function () { if (!document.hidden) dates(); });
  window.addEventListener('pageshow', dates);
  setInterval(dates, 60000);

  /* ---------- dialog ---------- */
  $$('[data-sd-dialog]').forEach(function (b) {
    b.addEventListener('click', function () { var dlg = document.getElementById(b.dataset.sdDialog); if (dlg && dlg.showModal) dlg.showModal(); });
  });
  $$('.sd-dialog').forEach(function (dlg) {
    dlg.addEventListener('click', function (e) { if (e.target === dlg) dlg.close(); });
    var x = dlg.querySelector('.sd-dialog__x'); if (x) x.addEventListener('click', function () { dlg.close(); });
  });

  /* ---------- sticky bar and sample pill ---------- */
  var mainAtc = $('.sd-atc'), sticky = $('.sd-sticky'), closeSec = $('.sd-close');
  if (mainAtc && sticky && 'IntersectionObserver' in window) {
    var atcVisible = true, closeVisible = false;
    var upd = function () { sticky.classList.toggle('is-on', !atcVisible && !closeVisible && mainAtc.getBoundingClientRect().top < 0); };
    new IntersectionObserver(function (en) { atcVisible = en[0].isIntersecting; upd(); }).observe(mainAtc);
    if (closeSec) new IntersectionObserver(function (en) { closeVisible = en[0].isIntersecting; upd(); }).observe(closeSec);
    window.addEventListener('scroll', function () { if (!atcVisible) upd(); }, { passive: true });
  }
  var banner = $('.sd-disclose'), pill = $('.sd-pill');
  if (banner && pill && 'IntersectionObserver' in window) {
    new IntersectionObserver(function (en) { pill.classList.toggle('is-on', !en[0].isIntersecting); }).observe(banner);
  }

  /* ---------- demo: say it, it draws it, it prints it ---------- */
  $$('.sd-demo').forEach(function (demo) {
    var dev = $('.sd-dev', demo);
    var scr = $('.sd-dev__screen', demo);
    var scrImg = scr ? scr.querySelector('img') : null;
    var said = $('[data-sd-said]', demo);
    var status = $('[data-sd-status]', demo);
    var paper = $('.sd-dev__paper', demo);
    var paperImg = paper ? paper.querySelector('img') : null;
    var picks = $$('.sd-say', demo);
    if (!dev || !scrImg || !picks.length) return;
    var timers = [];
    function clear() { timers.forEach(clearTimeout); timers = []; }
    function stage(name) { dev.setAttribute('data-stage', name); }
    function run(p) {
      clear();
      picks.forEach(function (x) { x.setAttribute('aria-pressed', x === p ? 'true' : 'false'); });
      if (said) said.textContent = p.dataset.say || '';
      scrImg.src = p.dataset.img; scrImg.alt = p.dataset.say || '';
      if (paperImg) { paperImg.src = p.dataset.img; paperImg.alt = ''; }
      if (reduced) { stage('printed'); if (status) status.textContent = status.dataset.done || ''; return; }
      stage('listening'); if (status) status.textContent = status.dataset.listen || '';
      timers.push(setTimeout(function () { stage('drawing'); if (status) status.textContent = status.dataset.draw || ''; }, 1100));
      timers.push(setTimeout(function () { stage('printing'); if (status) status.textContent = status.dataset.print || ''; }, 2500));
      timers.push(setTimeout(function () { stage('printed'); if (status) status.textContent = status.dataset.done || ''; }, 3900));
    }
    picks.forEach(function (p) { p.addEventListener('click', function () { run(p); }); });
    var first = picks.filter(function (p) { return p.getAttribute('aria-pressed') === 'true'; })[0] || picks[0];
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (en) { if (!en[0].isIntersecting) return; io.disconnect(); run(first); }, { threshold: .4 });
      io.observe(dev);
    } else { run(first); }
  });

  /* ---------- six styles picker ---------- */
  $$('.sd-styles').forEach(function (sec) {
    var tabs = $$('.sd-style', sec), big = $('.sd-styles__big img', sec), cap = $('[data-sd-style-cap]', sec);
    tabs.forEach(function (t) {
      t.addEventListener('click', function () {
        tabs.forEach(function (x) { x.setAttribute('aria-selected', x === t ? 'true' : 'false'); });
        if (big) { big.classList.remove('is-in'); void big.offsetWidth; big.src = t.dataset.img; big.alt = t.dataset.name || ''; big.classList.add('is-in'); }
        if (cap) cap.textContent = t.dataset.cap || '';
      });
    });
  });

  /* ---------- reveals (content stays visible without JS) ---------- */
  if (!reduced && 'IntersectionObserver' in window) {
    document.documentElement.classList.add('sd-js');
    var rio = new IntersectionObserver(function (en) {
      en.forEach(function (x) { if (x.isIntersecting) { x.target.classList.add('is-in'); rio.unobserve(x.target); } });
    }, { rootMargin: '0px 0px -8% 0px' });
    $$('.sd-reveal, .sd-print').forEach(function (el) { rio.observe(el); });
    setTimeout(function () { $$('.sd-reveal, .sd-print').forEach(function (el) { el.classList.add('is-in'); }); }, 6000);
  }

  render();
})();
